import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createNewMenu } from "../../../store/Menu/api";
import {useHistory} from "react-router";

export const useCreateNewMenu = () => {
    const history = useHistory();
    const queryClient = useQueryClient();

    return useMutation(['addNewMenu'], ({ params }) => createNewMenu(params), {
        onSuccess: async () => {
            await queryClient.invalidateQueries(['menu-list']);
            history.push(`/chain/menu`)
        },
    });
};
